import { render, staticRenderFns } from "./GlobalModal.vue?vue&type=template&id=1899b2f3&"
import script from "./GlobalModal.vue?vue&type=script&lang=js&"
export * from "./GlobalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports